export class SignPositionType {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignPositionTypesChoices = {
  LEFT: new SignPositionType('Links', 0),
  RIGHT: new SignPositionType('Rechts', 1),
  UNIMPORTANT: new SignPositionType('Onbepaald', 2)
};

export const SignPositionTypesChoiceArray = Object.values(
  SignPositionTypesChoices
);
